import { DOCUMENT } from '@angular/common';
import { Directive, ElementRef, afterNextRender, inject } from '@angular/core';

@Directive({ selector: '[mobiRunScripts]', standalone: true })
export class RunScriptsDirective {
  #elementRef = inject(ElementRef);
  #doc = inject(DOCUMENT);

  #afterRender = afterNextRender({
    write: () => {
      this.#reinsertScripts();
    },
  });

  #reinsertScripts(): void {
    const scripts = <HTMLScriptElement[]>(
      this.#elementRef.nativeElement.getElementsByTagName('script')
    );
    const scriptsInitialLength = scripts.length;
    for (let i = 0; i < scriptsInitialLength; i++) {
      const script: any = scripts[i];
      const scriptCopy = <HTMLScriptElement>this.#doc.createElement('script');
      scriptCopy.type = script.type ? script.type : 'text/javascript';
      if (script.innerHTML) {
        scriptCopy.innerHTML = script.innerHTML;
      } else if (script.src) {
        scriptCopy.src = script.src;
      }
      scriptCopy.async = false;
      script.parentNode.replaceChild(scriptCopy, script);
    }
  }
}
